import { MainLayout } from "@route/layout/main-layout";
import { createBrowserRouter } from "react-router-dom";
import { ErrorPage } from "./pages/error";

export const APP_ROUTES = {
  HOME: "/",
  LOGIN: "/login"
};

export const appRouter = createBrowserRouter([
  {
    path: APP_ROUTES.HOME,
    element: <MainLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: APP_ROUTES.HOME,
        async lazy() {
          const { HomePage } = await import("./pages/home");
          return { Component: HomePage };
        }
      }
    ]
  },
  {
    path: APP_ROUTES.LOGIN,
    errorElement: <ErrorPage />,
    async lazy() {
      const { LoginPage } = await import("./pages/login");
      return { Component: LoginPage };
    }
  }
]);
